import React from 'react';
import CenteredActivityResponseText from '../CenteredActivityResponseText/CenteredActivityResponseText';

function DeferredPaymentConfirmationDetails() {
  return <CenteredActivityResponseText text="Cette demande de paiement a été confirmée avec succès" />;
}

export default DeferredPaymentConfirmationDetails;
